module.exports = __webpack_public_path__ + "static/media/6-concealers-saturation.c30363bc.jpg";